import { createActionGroup, props } from '@ngrx/store';
import { FEATURE_NAME } from './automatic-top-up-config-dialog.constant';
import { AutoTopUp } from '@zerops/models/billing';

export const automaticTopUpConfigDialogActions = createActionGroup({
  source: FEATURE_NAME,
  events: {
    'open': props<{ data: { autoTopUp: AutoTopUp | null; }; }>()
  }
});
